import { DocumentNode } from 'graphql';
import React, { cloneElement } from 'react';
import { Command, useRunCommand } from 'src/hooks/query/use-run-command';
import { Replay } from '@otp/icons';
import { Can } from 'src/utils/can';
import { Actions, AppArea, Subjects } from 'src/graphql/generated/graphql';

type ReplayCommandProps = {
  command: Command;
  refetchQueries?: DocumentNode[];
  children?: React.ReactElement;
  onRun?: () => void;
};

export const ReplayCommand = ({
  command,
  refetchQueries,
  children,
  onRun,
}: ReplayCommandProps) => {
  const { runCommand } = useRunCommand();

  const handleClick = () => {
    runCommand(command, { refetchQueries });
    onRun?.();
  };

  const renderChildren = (children: React.ReactElement) =>
    cloneElement(children, { onClick: handleClick });

  let renderedChildren = <Replay onClick={handleClick} />;

  if (children) {
    renderedChildren = renderChildren(children);
  }

  return (
    <Can I={Actions.Write} a={Subjects.Jobs} appArea={AppArea.Most}>
      {renderedChildren}
    </Can>
  );
};
